<template>
  <tr class="access-point-controller-list-item">
    <td>
      <div class="access-point-controller-name-wrapper">
        <i v-if="item.controllerDefault" class="mdi mdi-star-circle"></i>
        {{ item.name }}
      </div>
    </td>

    <td>
      {{ controllerType }}
    </td>

    <td>
      <div class="actions-wrapper">
        <i
          v-if="isMonitoringController"
          class="mdi mdi-wifi pointer"
          v-tooltip="'Redes monitoradas'"
          @click="showingNetworkList = true"
        ></i>
        <i
          class="mdi mdi-square-edit-outline pointer"
          v-tooltip="$t('message.generics.message.edit')"
          @click="openEdit"
        ></i>
        <i
          class="mdi mdi-delete pointer"
          v-tooltip="$t('message.generics.message.delete')"
          @click.stop="showDeleteModal"
        ></i>
      </div>
    </td>

    <confirmation-modal
      :value="showingControllerDeleteModal"
      :confirm-label="$t('message.generics.message.confirm')"
      @confirm="deleteController"
      @cancel="closeDeleteModal"
    >
      <span slot="heading">
        {{ $t("message.spots.message.deleteController") }}
      </span>

      <span>
        {{ $t("message.spots.message.deleteControllerConfirmation") }}
      </span>
    </confirmation-modal>

    <access-point-controller-form
      :item="item"
      :manual-show="showingEditForm"
      no-activator
      @submit="onSubmit"
      @closed="resetShowingEdit"
    />

    <modal
      v-if="showingNetworkList"
      v-model="showingNetworkList"
      title="Redes monitoradas"
      max-width="fit-content"
    >
      <access-point-controller-network-list
        :controller-id="item.id"
        :selected-networks="selectedNetworks"
        @on-selected-network="setSelectedNetworks"
        @on-close="showingNetworkList = false"
      />
      <template #footer>
        <button
          class="btn btn-primary btn-extra-round"
          @click="updateControllerNetworks"
        >
          {{ $t("message.generics.message.save") }}
        </button>
      </template>
    </modal>
  </tr>
</template>

<script>
import AccessPointControllerForm from "@components/modules/access-point/controller/form/AccessPointControllerForm";
import ConfirmationModal from "@components/ConfirmationModal";
import AccessPointControllerNetworkList from "../../network/list/AccessPointControllerNetworkList.vue";
import Modal from "@components/generic/Modal.vue";
import EventBus from "@packages/event-bus";

export default {
  components: {
    ConfirmationModal,
    AccessPointControllerForm,
    AccessPointControllerNetworkList,
    Modal,
  },

  data() {
    return {
      showingControllerDeleteModal: false,
      showingEditForm: false,
      showingNetworkList: false,
      selectedNetworks: this.item.networks || [],
    };
  },

  props: {
    item: {
      type: Object,
    },
  },

  computed: {
    isMonitoringController() {
      return this.item.type === "CISCO_MERAKI" || this.item.type === "HUAWEI_IMASTER";
    },
    controllerType() {
      return this.isMonitoringController ? "Monitoramento" : "Captive";
    },
  },

  watch: {
    showingNetworkList() {
      this.$emit("on-handle-list-show");
    },
    showingEditForm() {
      this.$emit("on-handle-list-show");
    },
  },

  methods: {
    setSelectedNetworks(value) {
      this.selectedNetworks = value;
    },
    async updateControllerNetworks() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        await this.$api.core.accessPoint.controller.updateNetworks({
          controllerId: this.item.id,
          networks: this.selectedNetworks,
        });
        this.emitEdited();
        this.showingNetworkList = false;
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async deleteController() {
      await this.$api.core.accessPoint.controller.delete({
        controllerId: this.item.id,
      });

      this.closeDeleteModal();

      this.$emit("deleted");
    },
    closeDeleteModal() {
      this.showingControllerDeleteModal = false;
    },
    emitEdited() {
      this.$emit("edited");
    },
    openEdit() {
      this.showingEditForm = true;
    },
    resetShowingEdit() {
      this.showingEditForm = false;
    },
    onSubmit() {
      this.resetShowingEdit();
      this.emitEdited();
    },
    showDeleteModal() {
      this.showingControllerDeleteModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.access-point-controller-name-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.actions-wrapper {
  display: flex;
  gap: 4px;
}
</style>
